import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const chargeTemplateUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_FAILURE:
      const chargeTemplateFields: string[] = action.payload?.err?.fields || [];

      if (action.payload?.err.fields.includes("contactId")) {
        chargeTemplateFields.push("counterpartyId");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        chargeTemplateFields.push("counterpartyId");
      }
      
      return {
        ...state,
        isFetching: false,
        fields: chargeTemplateFields,
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        // isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };
        
    case Constants.GLOBAL_CHARGE_TEMPLATE_UPDATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
